module.exports = __webpack_public_path__ + "img/icon4.73b0b186.png";